import { BaseClient } from '@gogocj/core'
import { FC, createContext } from 'react'
import { JeffersonContextValueType } from '../types'

export const JeffersonContext = createContext<JeffersonContextValueType>({} as any)
JeffersonContext.displayName = 'JeffersonContext'

export const JeffersonProvider: FC<JeffersonContextValueType> = ({ JeffersonInstance, children }: { JeffersonInstance: BaseClient; children: any }) => {
  return <JeffersonContext.Provider value={{ JeffersonInstance }}>{children}</JeffersonContext.Provider>
}
